import React from 'react';

import bullet1 from '../static/images/bullets/bullet1.png';
import bullet2 from '../static/images/bullets/bullet2.png';
import bullet3 from '../static/images/bullets/bullet3.png';

const Bullets = () => (
  <div className="space-medium bg-white pt-5 pb-0">
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
          {/* section heading start */}
          <div className="section-heading mb-0">
            <h2 className="section-heading-title">AI That is Built on Solid Ground</h2>
            <p className="section-heading-text">
                To develop our AI platform, we leveraged everything we learned from our 17 years of experience delivering cyber defense to 700+ clients, and from our 1,000+ cybersecurity specialists monitoring billions of events. Our AI platform applies techniques including Supervised, Unsupervised, and Deep Learning, as well as NLP, to deliver high speed cybersecurity services across every stage of a threat's lifecycle:
            </p>
          </div>
          {/* section heading close */}
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-left">
          {/* process block start */}
          <div className="process-block-v1 process-block">
            <div className="process-block-content">
              <div className="icon-circle service-block-icon text-center">
                <img src={bullet1} alt="Threat Anticipation" />
              </div>
              <h4 className="process-block-title">Threat Anticipation</h4>
              <p className="process-block-text text-left">
              Our patent-pending platform mines over 100 TB of global threat data every day to detect new threats, correlate their impact (in seconds) on millions of your assets within your critical infrastructure and networks, and to proactively raise your defenses against the emerging threats most likely coming your way.
              </p>
            </div>
          </div>
          {/* process block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-left">
          {/* process block start */}
          <div className="process-block-v1 process-block">
            <div className="process-block-content">
              <div className="icon-circle service-block-icon text-center">
                <img src={bullet2} alt="Threat Anticipation" />
              </div>
              <h4 className="process-block-title">Threat Hunting</h4>
              <p className="process-block-text text-left">
                We deploy 25+ AI models, and 450+ use case scenarios, to proactively search for, and uncover, threats within your endpoint, user, network, and application data. Our AI platform can analyze 100 TB of data in seconds to detect any threat hiding in your network.
              </p>
            </div>
          </div>
          {/* process block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-left">
          {/* process block start */}
          <div className="process-block-v1 process-block">
            <div className="process-block-content">
              <div className="icon-circle service-block-icon text-center">
                <img src={bullet3} alt="Threat Anticipation" />
              </div>
              <h4 className="process-block-title">Incident Response</h4>
              <p className="process-block-text text-left">
              When we detect a threat, our AI platform performs automated containment measures—such as deploying 50+ playbook—to quickly remediate your threats. By leveraging our AI-Driven MDR service, you can reduce attacker dwell time—from malware to ransomware—from a months to under 3 days.
              </p>
            </div>
          </div>
          {/* process block close */}
        </div>
      </div>
    </div>
  </div>
);

export default Bullets;
